import React from 'react';
import { Link } from 'react-router-dom';

const SiteFooter = () => (
  <footer id="about" className="bg-gray-50 border-t border-gray-100 py-10">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="text-sm text-gray-400">
          © {new Date().getFullYear()} WebForms.biz. All rights reserved.
        </div>
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-gray-400">
          <Link to="/authentication" className="hover:text-gray-600 transition-colors">Login</Link>
          <Link to="/authentication" className="hover:text-gray-600 transition-colors">Sign up</Link>
          <Link to="/templates-gallery" className="hover:text-gray-600 transition-colors">Templates</Link>
          <Link to="/pricing" className="hover:text-gray-600 transition-colors">Pricing</Link>
          <Link to="/terms" className="hover:text-gray-600 transition-colors">Terms</Link>
          <Link to="/privacy" className="hover:text-gray-600 transition-colors">Privacy</Link>
        </div>
      </div>
    </div>
  </footer>
);

export default SiteFooter;